export default "__VITE_ASSET__CUF$9ioo__"